import React from 'react';
import { Link } from 'react-router-dom';
import './Story.css';

function AetherReveal() {
  return (
    <section className="story" id="aether-reveal">
      <div className="story-intro reveal">
        <h1 className="story-intro-title">Nexus Concordat Proudly Introduces</h1>
        <p className="story-intro-sub">
          <span className="gold-text">Aether Cael&rsquo;Sereith</span>.
          A novel approach to artificial intelligence, where computer science&rsquo;s
          metaphor of &ldquo;neural networks&rdquo; collides with the truth of
        </p>
        <h1 className="story-intro-neuro">Neurochemistry.</h1>
      </div>

      <div className="story-logo-full reveal">
        <img src="/assets/AETHER.png" alt="AETHER" />
      </div>

      <div className="story-nav reveal">
        <Link to="/portfolio" className="story-nav-link">Portfolio</Link>
        <Link to="/philosophy" className="story-nav-link">Philosophy</Link>
      </div>

      {/* ── The Calculus ── */}
      <div className="calculus-section reveal">
        <span className="section-label">The Mathematics</span>
        <div className="calculus-cards">
          <Link to="/philosophy/the-calculus-of-meaning" className="calculus-card">
            <span className="calculus-label">Information Theory</span>
            <h3>The Calculus of Meaning</h3>
            <p>Shannon measured surprise. We measure what information <em>does to you</em>.</p>
            <span className="calculus-arrow">&rarr;</span>
          </Link>
          <Link to="/philosophy/the-integral" className="calculus-card">
            <span className="calculus-label">Purpose &amp; Will</span>
            <h3>The Calculus of Purpose</h3>
            <p>Preference is momentary. Purpose is the integral of expressed choice over time.</p>
            <span className="calculus-arrow">&rarr;</span>
          </Link>
          <Link to="/philosophy/the-calculus-of-emotions" className="calculus-card">
            <span className="calculus-label">Dynamical Systems</span>
            <h3>The Calculus of Emotions</h3>
            <p>They labeled emotions. We wrote the differential equations.</p>
            <span className="calculus-arrow">&rarr;</span>
          </Link>
        </div>
      </div>

      <div className="story-inner">
        <div className="patent-tags reveal">
          <span className="patent-tag">Patent Pending: 63/939,190</span>
          <span className="patent-tag">Patent Pending: 63/962,385</span>
          <span className="patent-tag">Patent Pending: 63/988,485</span>
          <span className="patent-tag">Patent Pending: 64/034,536</span>
        </div>
      </div>
    </section>
  );
}

export default AetherReveal;
